import styled from "@emotion/styled";
import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import StyledFormInput from "./StyledFormInput";

const TextArea = forwardRef((props, ref) => {
  const { input, layout, config } = props;

  useImperativeHandle(ref, () => ({
    reset() {
      input.setValue("");
    },
  }));

  useEffect(() => {
    if (input?.startValue) input.inputRef.current.value = input.startValue;
  }, [input.startValue]);

  const onChange = () => {
    if (input.onChange) {
      input.onChange(input.inputRef.current.value);
    }
  };

  return (
    <StyledTextArea config={config}>
      <StyledFormInput
        config={config}
        className={`input__group input__textarea ${layout} ${input?.type}`}
      >
        <textarea
          ref={input?.inputRef}
          onInput={onChange}
          type={input?.type}
          {...input.inputOptions}
          required
        />
        <label>
          <div className={"label-bg"} />
          <span className={"label-show"}>{input?.label || "Input"}</span>
          <span className={"label-placeholder"}>{input?.label || "Input"}</span>
        </label>
        <span typo="caption-md" className="error">
          {input?.error}
        </span>
        {input?.append && <div className="append">{input?.append}</div>}
      </StyledFormInput>
    </StyledTextArea>
  );
});

export default TextArea;

/* style */

const StyledTextArea = styled.div`
  .input__textarea {
    textarea {
      resize: vertical;
    }
  }
`;
